import React, { useEffect, useState } from "react";
import { BACKEND_URL } from "@/lib/backendUrl";
import { useSearchParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { Button } from "@/components/ui/button";
import { Loader2, Check } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const API = `${BACKEND_URL}/api`;

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("polling");
  const [attempts, setAttempts] = useState(0);
  const navigate = useNavigate();
  const { refreshUser } = useAuth();

  useEffect(() => {
    if (!sessionId) { setStatus("error"); return; }
    let stop = false;
    const poll = async () => {
      if (stop) return;
      try {
        const r = await axios.get(`${API}/payments/status/${sessionId}`);
        if (r.data.payment_status === "paid") {
          setStatus("paid");
          await refreshUser();
          return;
        }
      } catch {}
      setAttempts(a => a + 1);
      if (attempts < 30 && !stop) setTimeout(poll, 2000);
      else setStatus("timeout");
    };
    poll();
    return () => { stop = true; };
    // eslint-disable-next-line
  }, [sessionId, attempts]);

  return (
    <div className="min-h-screen flex items-center justify-center px-6 bg-[#0B0E14] text-white">
      <div className="max-w-md w-full text-center space-y-6" data-testid="payment-success-page">
        {status === "polling" && (
          <>
            <Loader2 className="w-12 h-12 animate-spin mx-auto text-[#00F0FF]"/>
            <div className="font-display font-black text-2xl">Confirming your payment…</div>
            <div className="text-sm text-[#94A3B8] font-mono">Session {sessionId?.slice(-8)}</div>
          </>
        )}
        {status === "paid" && (
          <>
            <div className="w-16 h-16 rounded-full bg-[#00F0FF]/20 border-2 border-[#00F0FF] flex items-center justify-center mx-auto">
              <Check className="w-8 h-8 text-[#00F0FF]"/>
            </div>
            <div className="font-display font-black text-3xl">PRO UNLOCKED</div>
            <div className="text-[#94A3B8]">You can now save unlimited mixes and use full AI features.</div>
            <Button data-testid="return-to-studio-button" onClick={() => navigate("/studio")} className="bg-[#00F0FF] text-black hover:bg-[#33F3FF] font-black uppercase tracking-widest">Return to Studio</Button>
          </>
        )}
        {(status === "timeout" || status === "error") && (
          <>
            <div className="font-display font-black text-2xl">Still processing…</div>
            <div className="text-sm text-[#94A3B8]">Payment not confirmed yet. Please check back shortly.</div>
            <Button onClick={() => navigate("/studio")} className="bg-[#00F0FF] text-black">Back to Studio</Button>
          </>
        )}
      </div>
    </div>
  );
}
